import { render, staticRenderFns } from "./CheckoutPaymentsWrapper.vue?vue&type=template&id=41010a28&"
import script from "./CheckoutPaymentsWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports